import { useState, useCallback, useEffect } from 'react';

const useProductLoader = (initialProducts, productsPerPage) => {
  const [products, setProducts] = useState(initialProducts);
  const [visibleProducts, setVisibleProducts] = useState(
    initialProducts?.slice(0, productsPerPage),
  );
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const loadMoreProducts = useCallback(() => {
    const startIndex = page * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    const nextProducts = products?.slice(startIndex, endIndex);

    if (nextProducts?.length > 0) {
      setVisibleProducts((prev) => [...prev, ...nextProducts]);
      setPage((prevPage) => prevPage + 1);
    }
    setLoading(false);
  }, [page, products, productsPerPage]);

  useEffect(() => {
    setProducts(initialProducts);
    setVisibleProducts(initialProducts?.slice(0, productsPerPage));
    setPage(1);
    setLoading(false);
  }, [initialProducts, productsPerPage]);

  return {
    visibleProducts,
    loading,
    setLoading,
    loadMoreProducts,
  };
};

export default useProductLoader;
